import { useEffect } from 'react';
import { useAlert } from '@/shared/lib/hooks/useAlert';
import { legacyErrorMessages } from '@/shared/model/types/error';
import { normalizeApiError } from '@/shared/lib/utils/apiError';
import { linkifyEmail } from '@/shared/lib/utils/linkifyEmail';

export const useError = (error: any) => {
  const onAlert = useAlert();
  useEffect(() => {
    if (!error) return;
    const normalized = normalizeApiError(error);
    if (!normalized) {
      onAlert('Произошла неизвестная ошибка', true);
      return;
    }

    if (normalized.format === 'legacy') {
      const numericCode = typeof normalized.code === 'number' ? normalized.code : undefined;
      const fallback = numericCode != null ? legacyErrorMessages[numericCode] : undefined;

      onAlert(linkifyEmail(normalized.message || fallback || 'Произошла ошибка'), true);
      return;
    }

    onAlert(linkifyEmail(normalized.message), true);
  }, [error, onAlert]);
};
